export class Auth {
  user_pool_id: string;
  identity_pool_id: string;
  client_id: string;
}
